(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["rpl-location-video"] && !Shopify.designMode) return;
  try {
    document.querySelectorAll('[data-location-video]').forEach(function (film) {
  var button = film.querySelector('[data-location-video-play]');
  var videoId = film.dataset.locationVideo;
  var observer;
  var started = false;
  if (!button || !/^[A-Za-z0-9_-]{11}$/.test(videoId)) return;
  function startVideo(focusPlayer) {
    if (started) return;
    started = true;
    if (observer) observer.disconnect();
    var player = document.createElement('iframe');
    player.title = film.dataset.videoTitle;
    player.loading = 'lazy';
    player.allow = 'autoplay; encrypted-media; picture-in-picture';
    player.allowFullscreen = true;
    var controls = film.dataset.videoHideControls === 'true' ? '&controls=0' : '';
    player.src = 'https://www.youtube-nocookie.com/embed/' + videoId + '?autoplay=1&mute=1&playsinline=1&loop=1&playlist=' + videoId + '&rel=0' + controls;
    button.replaceWith(player);
    if (focusPlayer) player.focus();
  }
  button.addEventListener('click', function () { startVideo(true); }, { once: true });
  function enableAutoplay() {
    if (started || !('IntersectionObserver' in window)) return;
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    if (navigator.connection && navigator.connection.saveData) return;
    observer = new IntersectionObserver(function (entries) {
      if (entries.some(function (entry) { return entry.isIntersecting; })) startVideo(false);
    }, { threshold: 0.15 });
    observer.observe(film);
  }
  if (document.readyState === 'complete') enableAutoplay();
  else window.addEventListener('load', enableAutoplay, { once: true });
});
  } catch(e) { console.error(e); }
})();

})();
